<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoProceso :titulo="titulo" :accion="accion" @ejecutarAccion="ejecutarAccion" />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <SelectPuntoVenta :model="itemActivo.Id_PuntoVenta" :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarPuntoVenta" />
                </v-flex>
                <v-flex xs12 md1 offset-md1>
                  <v-text-field label="Prefijo*" v-model="itemActivo.PrefijoPuntoVenta" :rules="[rules.requerido]"
                    :readonly="true"></v-text-field>
                </v-flex>
                <v-flex xs6 md2>
                  <v-checkbox label="Controlador Fiscal" v-model="itemActivo.ImprimeCF" :readonly="true"></v-checkbox>
                </v-flex>
                <v-flex xs6 md2>
                  <v-checkbox label="Factura Electrónica" v-model="itemActivo.ImprimeFE" :readonly="true"></v-checkbox>
                </v-flex>
                <v-flex xs6 md2>
                  <v-checkbox label="Comprobantes de Prueba" v-model="itemActivo.HomologacionFE"
                    :readonly="true"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-data-table :headers="grillaHeaders_Comprobantes" :items="itemActivo.Comprobantes"
                    :loading="grillaLoading_Comprobantes" loading-text="Cargando..." :items-per-page="10" :footer-props="{
                        itemsPerPageText: 'Mostrar'
                      }" dense>
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <small>{{ item.Fecha | esFecha }}</small>
                        </td>
                        <td>
                          <v-chip small>{{
                            item.NombreTipoComprobanteLetraPrefijoNumero
                          }}</v-chip>
                        </td>
                        <td>
                          <v-chip v-if="esVentaContado(item.NombreCondicionVenta)" small outlined>{{
                            item.NombreCondicionVenta }}</v-chip>
                          <v-chip v-else small color="success" text-color="white">{{ item.NombreCondicionVenta }}</v-chip>
                        </td>
                        <td>
                          <small>{{ item.RazonSocial }}</small>
                        </td>
                        <td>
                          <small>{{ item.Cuit }}</small>
                        </td>
                        <td>
                          <small>{{ item.Nota }}</small>
                        </td>
                        <td class="text-right">
                          <strong>{{ item.Total | esMoneda }}</strong>
                        </td>
                        <td>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon x-small color="error" @click="borrar(item.Id_Venta)" v-on="on">
                                <v-icon>delete_outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Anular</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:no-data>-</template>
                    <template v-slot:[`footer.page-text`]="items">
                      {{ items.pageStart }} de {{ items.itemsLength }}
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje :activo="mensajeActivo" :tipo="mensajeTipo" :titulo="mensajeTitulo" :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion" />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import { eventBus } from "@/main";
import EncabezadoProceso from "@/components/EncabezadoProceso";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
export default {
  name: "AnulaImpresionFiscal",
  components: {
    EncabezadoProceso,
    PieCrud,
    Mensaje,
    SelectPuntoVenta
  },
  data() {
    return {
      titulo: "Anula Impresión Fiscal",
      itemVacio: {
        Id_PuntoVenta: 0,
        PrefijoPuntoVenta: 0,
        ImprimeCF: 0,
        ImprimeFE: 0,
        HomologacionFE: 0,
        Id_Venta: 0,
        Comprobantes: []
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      grillaHeaders_Comprobantes: [
        { text: "Fecha", sortable: false },
        {
          text: "Comprobante",
          value: "NombreTipoComprobanteLetraPrefijoNumero",
          sortable: false
        },
        { text: "Condición", value: "NombreCondicionVenta", sortable: false },
        { text: "Titular", value: "RazonSocial", width: "30%" },
        { text: "Cuit" },
        { text: "Nota", width: "20%" },
        { text: "Total", sortable: false },
        { text: "" }
      ],
      grillaLoading_Comprobantes: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  computed: {
    iFecha() {
      return this.itemActivo.Fecha
        ? moment(this.itemActivo.Fecha)
          .locale("es")
          .format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Ejecutar":
          if (this.$refs.form.validate()) this.buscar();
          break;
        case "AceptarConfirmacionBorrar":
          this.mostrarMensaje(false);
          this.anular();
          break;
        case "CancelarAviso":
        case "CancelarConfirmacionBorrar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      setTimeout(() => {
        eventBus.$emit("setearFocoSelectPuntoVenta");
      }, 100);
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.PrefijoPuntoVenta = item.Prefijo;
      this.itemActivo.ImprimeCF = item.ImprimeCF;
      this.itemActivo.ImprimeFE = item.ImprimeFE;
      this.itemActivo.HomologacionFE = item.HomologacionFE;
    },
    buscar() {
      this.grillaLoading_Comprobantes = true;
      this.itemActivo.Comprobantes = [];
      HttpHelper.get("Venta/ListarSinEstadoFiscal", {
        prefijo: this.itemActivo.PrefijoPuntoVenta
      })
        .then(response => {
          if (response.data.length == 0) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "No hay comprobantes",
              "No se encontraron comprobantes. Verifique e intente nuevamente."
            );
          } else this.itemActivo.Comprobantes = response.data;
          this.grillaLoading_Comprobantes = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    esVentaContado(valor) {
      return valor == this.$nombreCondicionVenta_Contado;
    },
    borrar(id) {
      this.itemActivo.Id_Venta = id;
      this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
    },
    anular() {
      this.loading = true;
      HttpHelper.get("Venta/ActualizarEstadoFiscal", {
        id_Venta: this.itemActivo.Id_Venta,
        estadoFiscal: "ANULADO"
      })
        .then(response => {
          this.loading = false;
          if (response.data) {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Listo",
              "El comprobante fué anulado con éxito."
            );
            this.buscar();
          } else {
            this.mostrarMensaje(
              true,
              "Aviso",
              "Anulación No Realizada",
              "El comprobante no pudo ser anulado. Verifique e intente nuevamente."
            );
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
